var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyLocation = function SvgPropertyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.817A6.849 6.849 0 0 1 19 8a7.293 7.293 0 0 1 2.438.43l-8.8-7.2a1 1 0 0 0-1.266 0l-11 9a1 1 0 0 0 1.266 1.548L3 10.656V22a1 1 0 0 0 1 1h12.753C15.191 21.478 12 17.981 12 14.817z",
    fill: "#D64309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a4.868 4.868 0 0 0-5 4.817c0 2.716 3.869 6.486 4.31 6.907l.69.66.69-.66c.441-.424 4.31-4.19 4.31-6.907A4.87 4.87 0 0 0 19 10zm0 7a2 2 0 1 1 0-3.999 2 2 0 0 1 0 4z",
    fill: "#D64309"
  })));
};
export default SvgPropertyLocation;